import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useRegionIndexQueryConfig} from '../../../query/Region/Query';
import SelectRegionsContent from './SelectRegionsContent';

const SelectRegions: FunctionComponent = () => {

    const [regionConfig] = useRegionIndexQueryConfig();
    const regionQuery = useQuery(regionConfig);

    return (
        <Page className={'select-regions'}>
            { regionQuery.data &&
                <SelectRegionsContent
                    regions={regionQuery.data} />
            }
        </Page>
    );
};

export default SelectRegions;
